import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './OfferGroup.css';

interface IOfferGroup {
  count?: string;
  link?: string;
  name?: string;
}

interface IOfferGroupProps {
  offerGroup: IOfferGroup;
  textLink: string;
  offers: React.ReactNode;
  onClick: () => void;
  position: number;
}

export const OfferGroup = ({ offerGroup, offers, position, textLink, onClick }: IOfferGroupProps) => {
  const handleAllOffersClick = () => {
    onClick();
    window.open(offerGroup.link, '_blank', 'noopener');
  };

  return (
    <div className={styles['container']}>
      <div className={styles['header']} data-name="OfferGroupHeader">
        <UIHeading2>{offerGroup.name}</UIHeading2>
        {Number(offerGroup.count) > 1 && offerGroup.link && (
          <span className={styles['all-offers-link']} onClick={handleAllOffersClick} role="button" tabIndex={0}>
            {textLink}
          </span>
        )}
      </div>
      <div key={`offers_${position}`} className={styles['offers-wrapper']}>
        {offers}
      </div>
    </div>
  );
};
